<template>
  <v-card>
    <v-card-title primary-title class="justify-center">
      <div>
        <div class="display-1 font-weight-medium blue--text">
          <v-icon large>help</v-icon>
          Help
        </div>
      </div>
    </v-card-title>
    <v-card-text>
      <v-flex xs8 offset-xs2>
        <v-container fluid grid-list-xs align-center text-xs-center>
          <v-layout row wrap>
            <v-flex xs12>
              <v-btn large block class="info" @click="openPage('help-signup')">
                Signing Up
              </v-btn>
            </v-flex>
            <v-flex xs12>
              <v-btn large block class="info" @click="openPage('help-signin')">
                Signing In
              </v-btn>
            </v-flex>
            <v-flex xs12 v-if="this.localUserAccessLevel == 2">
              <v-btn large block class="info" @click="openPage('help-userread')">
                Finding Users
              </v-btn>
            </v-flex>
            <v-flex xs12 v-if="this.localUserAccessLevel == 2">
              <v-btn large block class="info" @click="openPage('help-useractivate')">
                Activating Users
              </v-btn>
            </v-flex>
            <v-flex xs12 v-if="this.localUserAccessLevel == 2">
              <v-btn large block class="info" @click="openPage('help-userinvalidate')">
                Invalidating Users
              </v-btn>
            </v-flex>
            <v-flex xs12 v-if="this.localUserAccessLevel == 2">
              <v-btn large block class="info" @click="openPage('help-userfacilitiesadmin')">
                Managing Health Facilities and Physicians (for Administrators)
              </v-btn>
            </v-flex>
            <v-flex xs12 v-if="this.localUserAccessLevel == 2 || this.localUserType == 3">
              <v-btn large block class="info" @click="openPage('help-userfacilities')">
                Managing Health Facilities and Physicians (for Facilities)
              </v-btn>
            </v-flex>
            <v-flex xs12 v-if="this.localUserAccessLevel == 1 || this.localUserAccessLevel == 2">
              <v-btn large block class="info" @click="openPage('help-patientcreate')">
                Creating Patients
              </v-btn>
            </v-flex>
            <v-flex xs12 v-if="this.localUserAccessLevel == 2">
              <v-btn large block class="info" @click="openPage('help-patientread')">
                Finding Patients
              </v-btn>
            </v-flex>
            <v-flex xs12 v-if="this.localUserAccessLevel == 2">
              <v-btn large block class="info" @click="openPage('help-patientinvalidate')">
                Invalidating Patients
              </v-btn>
            </v-flex>
            <v-flex xs12 v-if="this.localUserAccessLevel == 1 || this.localUserAccessLevel == 2">
              <v-btn large block class="info" @click="openPage('help-certstandardcreate')">
                Creating Medical Certificates
              </v-btn>
            </v-flex>
            <v-flex xs12 v-if="this.localUserValid">
              <v-btn large block class="info" @click="openPage('help-certstandardread')">
                Finding Medical Certificates
              </v-btn>
            </v-flex>
            <v-flex xs12 v-if="this.localUserAccessLevel == 2">
              <v-btn large block class="info" @click="openPage('help-certstandardinvalidate')">
                Invalidating Medical Certificates
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<style>
  .cursor:hover{
    cursor: pointer;
  }
</style>

<script>
export default {
  props: ['localUserAccessLevel','localUserType','localUserValid'],
  data () {
    return {
      localUserAccessLevel: this.localUserAccessLevel,
      localUserType: this.localUserType,
      localUserValid: this.localUserValid
    }
  },
  methods: {
    openPage(name) {
      this.$emit("openPage", name);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/controllers/Help.vue